import {z} from 'zod';

import {BaseVoidResponseSchema, CreatedAtAndUpdatedBySchema} from '@dms/api/shared';

const ArticleUpdateJobItemSchema = z
  .object({
    id: z.string(),
    articleUpdateJobId: z.string(),
    state: z.enum(['BASKET', 'ADDED']),
    manufacturerId: z.string(),
    catalogNumber: z.string(),
  })
  .merge(CreatedAtAndUpdatedBySchema);
export type ArticleUpdateJobItem = z.infer<typeof ArticleUpdateJobItemSchema>;

const AddBasketItemBodySchema = z.object({
  catalogNumber: z.array(z.string()),
  manufacturerId: z.array(z.string()),
});
export type AddBasketItemBody = z.infer<typeof AddBasketItemBodySchema>;

/**
 * GET
 */
export const GetArticleUpdateJobBasketRequestSchema = z.object({
  articleUpdateJobId: z.string(),
});
export type GetArticleUpdateJobBasketRequest = z.infer<
  typeof GetArticleUpdateJobBasketRequestSchema
>;

export const GetArticleUpdateJobBasketResponseSchema = z.object({
  articleUpdateJobItem: z.array(ArticleUpdateJobItemSchema),
});

export type GetArticleUpdateJobBasketResponse = z.infer<
  typeof GetArticleUpdateJobBasketResponseSchema
>;

/**
 * POST
 */
export const CheckoutArticleUpdateJobBasketRequestSchema = z.object({
  articleUpdateJobId: z.string(),
});
export type CheckoutArticleUpdateJobBasketRequest = z.infer<
  typeof CheckoutArticleUpdateJobBasketRequestSchema
>;

export const CheckoutArticleUpdateJobBasketResponseSchema = BaseVoidResponseSchema;
export type CheckoutArticleUpdateJobBasketResponse = z.infer<
  typeof CheckoutArticleUpdateJobBasketResponseSchema
>;

export const PostArticleUpdateJobBasketItemsRequestSchema = z.object({
  articleUpdateJobId: z.string(),
  body: AddBasketItemBodySchema,
});
export type PostArticleUpdateJobBasketItemsRequest = z.infer<
  typeof PostArticleUpdateJobBasketItemsRequestSchema
>;

export const PostArticleUpdateJobBasketItemsResponseSchema = z.object({
  articleUpdateJobItemId: z.array(z.string()),
});
export type PostArticleUpdateJobBasketItemsResponse = z.infer<
  typeof PostArticleUpdateJobBasketItemsResponseSchema
>;

/**
 * PATCH
 */
export const DiscardArticleUpdateJobBasketRequestSchema = z.object({
  articleUpdateJobId: z.string(),
});
export type DiscardArticleUpdateJobBasketRequest = z.infer<
  typeof DiscardArticleUpdateJobBasketRequestSchema
>;

export const DiscardArticleUpdateJobBasketResponseSchema = BaseVoidResponseSchema;
export type DiscardArticleUpdateJobBasketResponse = z.infer<
  typeof DiscardArticleUpdateJobBasketResponseSchema
>;

/**
 * DELETE
 */
export const DeleteArticleUpdateJobItemsRequestSchema = z.object({
  articleUpdateJobId: z.string(),
  body: z.object({
    articleUpdateJobItemId: z.array(z.string()),
  }),
});
export type DeleteArticleUpdateJobItemsRequest = z.infer<
  typeof DeleteArticleUpdateJobItemsRequestSchema
>;

export const DeleteArticleUpdateJobItemsResponseSchema = BaseVoidResponseSchema;
export type DeleteArticleUpdateJobItemsResponse = z.infer<
  typeof DeleteArticleUpdateJobItemsResponseSchema
>;

/**
 * PUT
 */
